module.exports = __webpack_public_path__ + "img/b2b06.64ef4b1b.png";